import { Link, createFileRoute } from '@tanstack/react-router'
import { BookOpen } from 'lucide-react'
import { ChiliPiperWebhooksCard } from './-components/ChiliPiperWebhooksCard'
import { DeliveryTargetCard } from './-components/DeliveryTargetCard'
import { EscapePlanHostAutoAssignCard } from './-components/EscapePlanHostAutoAssignCard'
import { GapSettingsCard } from './-components/GapSettingsCard'
import { HolidaysCard } from './-components/HolidaysCard'
import { PageTitle } from '@/components/PageTitle'
import { RequireAdmin } from '@/components/permissions/RequireDepartment'
import { Button } from '@/components/ui/button'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { requirePermission } from '@/lib/permissions/route-guards'
import { BACKOFFICE_PERMISSION_KEYS } from '@/lib/permissions/backoffice-permissions'

export const Route = createFileRoute('/_app/backoffice/journey-scheduling/')({
  component: RouteComponent,
  beforeLoad: requirePermission(BACKOFFICE_PERMISSION_KEYS.journeyScheduling),
})

function RouteComponent() {
  return (
    <div className="py-4">
      <PageTitle title="Journey Scheduling" />

      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/backoffice">Backoffice</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Journey Scheduling</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="mb-4">
        <div className="flex items-start justify-between gap-3 sm:items-center">
          <h1 className="min-w-0 text-2xl font-bold tracking-tight sm:text-3xl">
            Journey Scheduling
          </h1>
          <Button asChild variant="outline" className="h-11 sm:h-9">
            <Link to="/backoffice/journey-scheduling/meeting-types">
              <BookOpen className="size-4" aria-hidden="true" />
              Meeting Types
            </Link>
          </Button>
        </div>
        <p className="mt-1 text-sm text-muted-foreground">
          The delivery target, the default gaps between client journey sessions,
          the business holiday calendar behind the booking suggestions, the
          Chili Piper webhooks that keep the journey in sync and, for admins,
          the Escape Plan host check that can run right away.
        </p>
      </div>

      <div className="space-y-4">
        <DeliveryTargetCard />
        <RequireAdmin>
          <EscapePlanHostAutoAssignCard />
        </RequireAdmin>
        <GapSettingsCard />
        <HolidaysCard />
        <ChiliPiperWebhooksCard />
      </div>
    </div>
  )
}
